import { useState } from "react";

import { Row, Col, Card } from "react-bootstrap";

import { profiles } from "../Data";

const Profiles = () => {
    const [copied, setCopied] = useState("");

    const copyHandler = (url) => {
        setCopied(url);
        if (url.includes("mailto") === true) {
            url = url.substring(7);
        }
        navigator.clipboard.writeText(url);
        setTimeout(() => setCopied(""), 500);
    };

    return (
        <>
            <Row
                style={{ fontWeight: "bold" }}
            >
            {profiles.map((profile) => (
                <Col md={6} className="mb-1">
                    <Card>
                        <Card.Body>
                            <div className="d-flex justify-content-between">
                                <b style={{ color: profile.color }}>
                                    {profile.icon} {profile.name}
                                </b>
                                <div style={{ fontStyle: "italic" }}>
                                    {copied === profile.url ? (
                                        "Copied"
                                    ) : (
                                        <u
                                            onClick={() =>
                                                copyHandler(profile.url)
                                            }
                                            style={{ cursor: "pointer" }}
                                        >
                                            Copy
                                        </u>
                                    )}
                                    <a
                                        href={profile.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="ms-3"
                                    >
                                        Open
                                    </a>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            ))}
            </Row>
        </>
    );
};

export default Profiles;
